import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { hocKyDangKyApi } from "../../../api/category/hocKyDangKyApi";
import { rootActions } from "../../actions/rootActions";
import { eHocKyDangKyActionIds } from "../../action-types/category/IHocKyDangKyActions";
const mainAction = rootActions.category.hocKyDangKy;

export function* hocKyDangKySaga(): any {
    yield takeLatest(eHocKyDangKyActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
    const res : IBaseResponse = yield call(hocKyDangKyApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Học kỳ đăng ký"));
    }
}